import React, { useEffect, useState } from 'react';

import { Button, Col, Row, Select } from 'antd';

import { ClearOutlined } from '@ant-design/icons';
import { useSupplier } from 'lib/providers/SupplierContextProvider';

type Filter = {
  name?: string;
  service?: string;
  email?: string;
  responsible?: string;
  cellphone?: string;
  phone?: string;
};

export function Filters() {
    const [filter, setFilter] = useState<Filter>({});

    const {
        suppliers,
        setSuppliersFiltered,
        supplierNames,
        supplierCategories,
        emailOptions,
        responsibleOptions,
        cellphoneOptions,
        phoneOptions
    } = useSupplier();

    useEffect(() => {
        let data = [...suppliers];

        if (filter.name) {
            data = data.filter(s =>
                s.name?.toLowerCase().includes(filter.name!.toLowerCase())
            );
        }

        if (filter.service) {
            data = data.filter(s =>
                s.supplier_service_category?.some(sc =>
                    sc.service_category?.name?.toLowerCase().includes(filter.service!.toLowerCase())
                )
            );
        }

        if (filter.email) {
            data = data.filter(s =>
                s.email?.toLowerCase().includes(filter.email!.toLowerCase())
            );
        }

        if (filter.responsible) {
            data = data.filter(s =>
                s.accountable?.toLowerCase().includes(filter.responsible!.toLowerCase())
            );
        }

        if (filter.cellphone) {
            data = data.filter(s =>
                s.phone_1?.toLowerCase().includes(filter.cellphone!.toLowerCase())
            );
        }

        if (filter.phone) {
            data = data.filter(s =>
                s.phone_2?.toLowerCase().includes(filter.phone!.toLowerCase())
            );
        }

        setSuppliersFiltered(data);
    }, [filter, suppliers, setSuppliersFiltered]);

    const colProps = {
        style: { marginTop: 5 },
        xs: 24,
        sm: 24,
    };

    const Name = () => (
        <Select
            placeholder="Nome"
            value={filter.name}
            onChange={(value) => setFilter({ ...filter, name: value })}
            allowClear
            showSearch
            style={{ width: '100%' }}
            options={supplierNames.map(value => ({ label: value, value }))}
        />
    );

    const Service = () => (
        <Select
            placeholder="Serviço"
            value={filter.service}
            onChange={(value) => setFilter({ ...filter, service: value })}
            allowClear
            showSearch
            style={{ width: '100%' }}
            options={supplierCategories.map(value => ({ label: value, value }))}
        />
    );

    const Email = () => (
        <Select
            placeholder="E-mail"
            value={filter.email}
            onChange={(value) => setFilter({ ...filter, email: value })}
            allowClear
            showSearch
            style={{ width: '100%' }}
            options={emailOptions.map(value => ({ label: value, value }))}
        />
    );

    const Responsible = () => (
        <Select
            placeholder="Responsável"
            value={filter.responsible}
            onChange={(value) => setFilter({ ...filter, responsible: value })}
            allowClear
            showSearch
            style={{ width: '100%' }}
            options={responsibleOptions.map(value => ({ label: value, value }))}
        />
    );

    const Cellphone = () => (
        <Select
            placeholder="Celular"
            value={filter.cellphone}
            onChange={(value) => setFilter({ ...filter, cellphone: value })}
            allowClear
            showSearch
            style={{ width: '100%' }}
            options={cellphoneOptions.map(value => ({ label: value, value }))}
        />
    );

    const Phone = () => (
        <Select
            placeholder="Telefone"
            value={filter.phone}
            onChange={(value) => setFilter({ ...filter, phone: value })}
            allowClear
            showSearch
            style={{ width: '100%' }}
            options={phoneOptions.map(value => ({ label: value, value }))}
        />
    );

    const ClearFilter = () => (
        <Button
            type="primary"
            icon={<ClearOutlined />}
            onClick={() => setFilter({})}
            title="Limpar filtros"
        />
    );

    return (
        <Row align="middle" gutter={16}>
            <Col {...colProps} md={3} lg={3} ><Name /></Col>
            <Col {...colProps} md={3} lg={3} ><Service /></Col>
            <Col {...colProps} md={3} lg={3} ><Email /></Col>
            <Col {...colProps} md={4} lg={4} ><Responsible /></Col>
            <Col {...colProps} md={4} lg={4} ><Cellphone /></Col>
            <Col {...colProps} md={4} lg={4} ><Phone /></Col>
            <Col {...colProps} md={1} lg={1}>
                <ClearFilter />
            </Col>
        </Row>
    );
}
